import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/i18n/I18nContext";
import { PageHeader, Chip, statusVariant, EmptyState } from "@/components/ui-bits";
import { Check, X as XIcon } from "lucide-react";
import { toast } from "sonner";

export default function Timesheets() {
  const { t } = useI18n();
  const [list, setList] = useState([]);
  const load = async () => setList((await api.get("/time-approvals?status=submitted")).data);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, []);
  const decide = async (id, status) => {
    await api.post(`/time-approvals/${id}/decide`, { status });
    toast.success(t("saved")); load();
  };
  return (
    <div data-testid="page-timesheets">
      <PageHeader eyebrow={t("time_approvals")} title={t("time_approvals")} />
      {list.length === 0 ? <EmptyState /> : (
        <div className="card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="border-b hairline"><tr className="text-left">
              <th className="p-3 eyebrow">{t("employee")}</th>
              <th className="p-3 eyebrow">{t("date")}</th>
              <th className="p-3 eyebrow">{t("start")}</th>
              <th className="p-3 eyebrow">{t("end")}</th>
              <th className="p-3 eyebrow">{t("status")}</th>
              <th className="p-3 eyebrow text-right"></th>
            </tr></thead>
            <tbody>
              {list.map((r) => (
                <tr key={r._id} className="border-t hairline" data-testid={`time-${r._id}`}>
                  <td className="p-3 font-semibold">{r.employee_name}</td>
                  <td className="p-3 font-mono text-xs">{r.shift_date}</td>
                  <td className="p-3 font-mono">{r.actual_start}</td>
                  <td className="p-3 font-mono">{r.actual_end}</td>
                  <td className="p-3"><Chip variant={statusVariant(r.status)}>{t(r.status)}</Chip></td>
                  <td className="p-3 text-right">
                    <div className="inline-flex gap-1">
                      <button onClick={() => decide(r._id, "approved")} className="btn btn-primary !h-8" data-testid={`approve-time-${r._id}`}><Check size={12} />{t("approve")}</button>
                      <button onClick={() => decide(r._id, "rejected")} className="btn btn-ghost !h-8" data-testid={`reject-time-${r._id}`}><XIcon size={12} />{t("reject")}</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
